import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-document-list-emd.actions';
import { GetDocumentListEmdState } from './get-document-list-emd.state';

/**
 * getDocumentListEmd initial state
 */
export const getDocumentListEmdInitialState: GetDocumentListEmdState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetDocumentListEmd Store
 */
export const getDocumentListEmdReducerFeatures: ReducerTypes<GetDocumentListEmdState, ActionCreator[]>[] = [
  on(actions.setGetDocumentListEmd, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetDocumentListEmd, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetDocumentListEmd, () => getDocumentListEmdInitialState),

  on(actions.cancelGetDocumentListEmdRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetDocumentListEmd, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetDocumentListEmdFromApi, actions.updateGetDocumentListEmdFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetDocumentListEmd Store reducer
 */
export const getDocumentListEmdReducer = createReducer(
  getDocumentListEmdInitialState,
  ...getDocumentListEmdReducerFeatures
);
